import { t } from 'i18next';
import type { ImageValidity } from '@Medsicheck/medsi-web-sdk';

export const MEDSI_SCAN_ERROR_KEYS = {
  CHUNK_UPLOAD_FAILED: 'medsi_error_chunk_upload_failed',
  VITAL_PREDICT_TIMEOUT: 'medsi_error_vital_predict_timeout',
} as const;

export type MedsiScanErrorKey =
  (typeof MEDSI_SCAN_ERROR_KEYS)[keyof typeof MEDSI_SCAN_ERROR_KEYS];

const MEDSI_SCAN_ERROR_KEY_SET = new Set<string>(
  Object.values(MEDSI_SCAN_ERROR_KEYS),
);

export function getMedsiFaceValidityMessage(
  validity: ImageValidity | string,
): string {
  switch (validity) {
    case 'VALID':
      return '';
    case 'HEAD_TILTED':
      return t('keep_head_straight');
    case 'HEAD_TURNED':
      return t('look_at_camera');
    case 'FACE_TOO_SMALL':
      return t('move_closer');
    case 'FACE_TOO_LARGE':
      return t('move_further');
    case 'FACE_OFF_CENTER':
      return t('center_your_face');
    case 'POOR_LIGHTING':
      return t('face_is_evenly_illuminated');
    case 'MULTIPLE_FACES':
      return t('single_face_only');
    case 'NO_FACE':
    default:
      return t('face_not_detected');
  }
}

export function translateMedsiScanError(
  error: string | undefined,
  code?: number,
): string {
  if (error && MEDSI_SCAN_ERROR_KEY_SET.has(error)) {
    return t(error);
  }

  if (error) {
    const normalized = error.toLowerCase();
    if (
      normalized.includes('notallowederror') ||
      normalized.includes('permission denied') ||
      normalized.includes('permission dismissed')
    ) {
      return t('medsi_error_camera_permission_denied');
    }
    if (
      normalized.includes('notfounderror') ||
      normalized.includes('devices not found') ||
      normalized.includes('requested device not found')
    ) {
      return t('medsi_error_camera_not_found');
    }
  }

  if (code === 1) {
    return t('medsi_error_camera_init');
  }
  if (code === 2) {
    return t('medsi_error_scan_start');
  }

  return error ? error : t('medsi_error_scan_generic');
}
